import Layout from 'antd/es/layout';
const { Content } = Layout;

export default Content;
